<template>
  <div
    class="paid-feature-paywall-wrapper"
    :style="backgroundImageStyle"
  >
    <NoResource>
      <template #header>
        <span class="font-medium text-xl">{{ props.title }}</span>
      </template>
      <template #body>
        <span class="text-center">{{ props.description }}</span>
      </template>
      <template #footer>
        <Badge
          class="upgrade-plan-button"
          :text="'upgradePlan'"
          @click="openUpgradePlan"
        />
      </template>
    </NoResource>
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue';
import constants from '@/utilities/constants';
import { useStore } from 'vuex';
import NoResource from '@/components/widgets/NoResource';
import onPageLoad from '@/utilities/composables/useOnPageLoad';
import Badge from '@/components/elements/Badge';

const props = defineProps<{
  title: string;
  description: string;
  backgroundImageUrl?: string;
}>();

const store = useStore();

const backgroundImageStyle = computed(() => {
  if (!props.backgroundImageUrl) return { background: 'var(--backgroundStrongest)' };

  return {
    backgroundImage: `url(${props.backgroundImageUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };
});

const openUpgradePlan = () => {
  store.dispatch('setShowUpgradePlanPopup', constants.featureFlagIds.roadmapAndProjects);
};

onMounted(() => {
  onPageLoad();
});
</script>

<style lang="scss">
.paid-feature-paywall-wrapper {
  @apply text-text-default text-sm flex justify-center;
  height: calc(100vh - #{$headerHeight});

  .no-resource-wrap {
    @apply m-0 mt-[18%] self-start bg-standard-bg border-important-border;
  }

  .upgrade-plan-button {
    @apply text-sm py-0.5;
  }
}
</style>
